import { PASSWORD_MIN_LENGTH, passwordPolicy } from "@lib/passwordPolicy"
import { z } from "zod"

// The full policy, client-side, each rule failing with the same code the
// server would return — so the activation page can show the whole list up
// front instead of two rules here and five surprises after submit (PRD-60
// chunk A). The server stays authoritative (core/password_policy.py) and
// answers with the first violation it finds; the checklist makes that a
// rare event rather than the normal path.
export const setPasswordSchema = z
  .object({
    new_password: z
      .string()
      .min(PASSWORD_MIN_LENGTH, "password_too_short")
      .refine(passwordPolicy.hasLower, "password_missing_lowercase")
      .refine(passwordPolicy.hasUpper, "password_missing_uppercase")
      .refine(passwordPolicy.hasDigit, "password_missing_digit")
      .refine(passwordPolicy.noConsecutiveDigits, "password_consecutive_digits")
      .refine(passwordPolicy.noConsecutiveLetters, "password_consecutive_letters")
      .refine(passwordPolicy.noRepeatingChars, "password_repeating_chars")
      .refine(passwordPolicy.noForbiddenWords, "password_contains_forbidden_word"),
    confirm_password: z.string().min(1, "confirm_required"),
  })
  .refine((data) => data.new_password === data.confirm_password, {
    message: "password_mismatch",
    path: ["confirm_password"],
  })

export type SetPasswordInput = z.infer<typeof setPasswordSchema>
